'use strict';

var React = require('react');
var Typography = require('../../../DesignSystem/DataDisplay/Typography/Typography.js');
var CurrencyDisplay = require('../../CurrencyDisplay.js');
var LineItemImageAndText = require('./LineItemImageAndText.js');
var withStyles = require('../../../node_modules/@material-ui/core/esm/styles/withStyles.js');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var React__default = /*#__PURE__*/_interopDefaultLegacy(React);

var styles = {
  tableRow: {
    paddingTop: 8,
    paddingBottom: 8,
    paddingRight: 8
  }
};

var LineItemRow = function LineItemRow(_ref) {
  var lineItem = _ref.lineItem,
      settings = _ref.settings,
      hasLineItemImages = _ref.hasLineItemImages,
      isPDF = _ref.isPDF,
      classes = _ref.classes;
  var name = lineItem.name,
      quantity = lineItem.quantity,
      unit_price = lineItem.unit_price,
      description = lineItem.description,
      image_url = lineItem.image_url;
  var show_quantity_and_unit_price = settings.show_quantity_and_unit_price,
      show_amount = settings.show_amount;
  var amount = quantity * unit_price;
  var itemWidthPercent = 60;
  if (!show_quantity_and_unit_price) itemWidthPercent += 24;
  if (!show_amount) itemWidthPercent += 16;
  return React__default["default"].createElement("tr", {
    style: {
      pageBreakInside: 'avoid'
    }
  }, React__default["default"].createElement("td", {
    valign: "top",
    style: {
      width: itemWidthPercent + '%',
      paddingLeft: 8
    }
  }, React__default["default"].createElement(LineItemImageAndText, {
    hasLineItemImages: hasLineItemImages,
    imageUrl: image_url,
    name: name,
    description: description,
    isPDF: isPDF
  })), show_quantity_and_unit_price && React__default["default"].createElement(React.Fragment, null, React__default["default"].createElement("td", {
    valign: "top"
  }, React__default["default"].createElement(Typography, {
    align: 'right',
    className: classes.tableRow
  }, quantity)), React__default["default"].createElement("td", {
    valign: "top"
  }, React__default["default"].createElement(Typography, {
    align: 'right',
    className: classes.tableRow
  }, React__default["default"].createElement(CurrencyDisplay, {
    amountInCents: unit_price
  })))), show_amount && React__default["default"].createElement("td", {
    valign: "top"
  }, React__default["default"].createElement(Typography, {
    align: 'right',
    className: classes.tableRow
  }, React__default["default"].createElement(CurrencyDisplay, {
    amountInCents: amount
  }))));
};

var LineItemRow$1 = withStyles(styles)(LineItemRow);

module.exports = LineItemRow$1;
